import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class SharedDataService {

  private lastDialogflowAnswer = new Subject<object>();

  constructor() {
  }

  updateDialogflowAnswer(object: object) {
    this.lastDialogflowAnswer.next(object);
  }

  getDialogflowAnswer(): Observable<object> {
    return this.lastDialogflowAnswer.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/shared-data.service.ts